import clsx from "clsx";
import React from "react";
import { Box } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  root: {
    width: theme.spacing(4.5),
    height: theme.spacing(4.5),
    minWidth: theme.spacing(4.5),
    backgroundColor: theme.palette.common.white,
    borderRadius: "50%",
    border: `2px solid ${theme.palette.grey[400]}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.2s ease",
  },

  selected: {
    backgroundColor: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
  },

  check: {
    color: theme.palette.common.white,
    fontSize: 20,
  },
}));

export interface RadioIndicatorProps {
  selected?: boolean;
}

export function RadioIndicator({ selected }: RadioIndicatorProps) {
  const s = useStyles();

  return (
    <Box className={clsx(s.root, selected && s.selected)}>
      {selected && <CheckIcon className={s.check} />}
    </Box>
  );
}
